import { render, staticRenderFns } from "./xxpx.vue?vue&type=template&id=6cf8696c&scoped=true&"
import script from "./xxpx.vue?vue&type=script&lang=js&"
export * from "./xxpx.vue?vue&type=script&lang=js&"
import style0 from "./xxpx.vue?vue&type=style&index=0&id=6cf8696c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf8696c",
  null
  
)

export default component.exports